<template>
  <div id="Login2">
    <div id="LoginCard">
      <p style="font-size: 20px; padding-top: 30px">课程顾问/学管 登录</p>
      <p>
        <a-card
          style="width: 100%"
          :tab-list="tabListNoTitle"
          :active-tab-key="noTitleKey"
          @tabChange="(key) => onTabChange(key, 'noTitleKey')"
        >
          <div v-if="noTitleKey === 'pswlogin'">
            登陆账号：<a-input
              key="account"
              v-model="account"
              id="account"
              placeholder="S401登陆账号(一般为私人手机号)"
            />
            <p>
              登陆密码：
              <a-input placeholder="输入S401 登陆密码" id="password" />
            </p>
            <!-- <a-input placeholder="输入外呼系统授权编号" id="callauth" /> -->
            <p>
              谷歌验证码：
              <a-input placeholder="输入谷歌验证码" id="googleauth" />
            </p>
            <a-button type="primary" :loading="loading" @click="loginS401()"
              >登陆</a-button
            >
          </div>
          <div v-else-if="noTitleKey === 'scanlogin'" v-on="showDingCode()">
            <iframe
              id="dingifr"
              width="300"
              height="275"
              style="overflow: hidden; border: medium none"
            ></iframe>
          </div>
        </a-card>
      </p>
    </div>

    <div id="MathLoginCard">
      <p style="font-size: 20px; padding-top: 30px">数学项目 登录</p>
      <p>
        登陆账号：<a-input
          key="mathaccount"
          v-model="mathaccount"
          id="mathaccount"
          placeholder="数学登陆账号(一般为私人手机号)"
        />
      </p>
      <p>
        登陆密码：
        <a-input placeholder="输入登陆密码" id="mathpassword" />
      </p>
      <!-- <a-input placeholder="输入外呼系统授权编号" id="callauth" /> -->
      <p>
        谷歌验证码：
        <a-input placeholder="输入谷歌验证码" id="mathgoogleauth" />
      </p>
      <a-button type="primary" :loading="mathloading" @click="loginMath()"
        >登陆</a-button
      >
    </div>

    <a-modal v-model="visible" title="外呼信息绑定" onOk="handleOk">
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="bindS401"
        >
          绑定
        </a-button>
      </template>
      <p>应运营商要求，所有外呼均需提供使用者身份证信息，用于信息登记。</p>
      <p>身份信息仅做合法校验使用，不会用于其他用途。</p>
      <p>真实姓名：<a-input placeholder="输入身份证上的姓名" id="IDname" /></p>
      <p>身份证号：<a-input placeholder="输入身份证号码" id="IDcode" /></p>
      <p>
        接听手机号：<a-input placeholder="输入用于接听的手机号" id="phone" />
      </p>
      <p style="color: red">
        接听手机号为顾问用于呼叫使用的手机号，一般为工作手机号
      </p>
    </a-modal>
    <footer class="footer">
      <a href="http://beian.miit.gov.cn">闽ICP备19004112号</a>
    </footer>
    <div>
      <a-modal v-model="showSelectAccount" title="选择账号登陆" footer="">
        <ul>
          <li v-for="item in dingdingUserArr" :key="item.name">
            <a @click="dingdingLogin(item.id)"
              >{{ item.name }}-{{ item.mobile }}</a
            >
          </li>
        </ul>
        <!-- <a-list item-layout="horizontal" :data-source="data">
          <a-list-item
            v-for="user in dingdingUserArr"
            slot="user"
            slot-scope="item, index"
          >
            user.ID
          </a-list-item>
        </a-list> -->
      </a-modal>
    </div>
  </div>
</template>

<script>
import { Login, LoginMath, BindCall, GetBoundAdmins, LoginByDingTalk } from '@/api/QkidsApi.js'
import { setUserInfo } from '@/api/axios.js'
import Message from 'ant-design-vue/lib/message'

export default {
  name: 'Login2',
  data: () => {
    return {
      appid: 'dingoahhssxqap8sbeqqhu',
      s401type: 'qkids',
      account: '',
      mathaccount: '',
      visible: false,
      visiblemath: false,
      loading: false,
      loadingmath: false,
      accesstoken: '',
      refreshtoken: '',
      mathloading: false,
      tabListNoTitle: [
        {
          key: 'pswlogin',
          tab: '账号密码登陆'
        },
        {
          key: 'scanlogin',
          tab: '钉钉扫码登陆'
        }
      ],
      key: 'pswlogin',
      noTitleKey: 'pswlogin',
      dingdingCode: '',
      dingdingUserArr: [],
      showSelectAccount: false
    }
  },
  watch: {
    account (val) {
      console.log(val)
      this.account = val
    },
    mathaccount (val) {
      this.mathaccount = val
    }
  },
  methods: {
    dingdingLogin (id) {
      console.log('dingdingLogin:' + this.dingdingCode + '|' + id)
      LoginByDingTalk(this.dingdingCode, id)
        .then(req => {
          this.s401type = 'qkids'
          localStorage.s401type = 'qkids'
          this.accesstoken = JSON.parse(atob(req.data)).access_token
          this.refreshtoken = JSON.parse(atob(req.data)).refresh_token
          setUserInfo(this.accesstoken, this.refreshtoken)
          if (req.needIDInfo === 0) {
            localStorage.personID = req.person.id
            localStorage.isAdmin = req.person.admin
            this.account = req.person.login_account
            this.$router.push('/call')
          } else {
            this.dingdingUserArr.forEach((u) => {
              if (u.id === id) {
                this.account = u.mobile
              }
            }
            )
            this.visible = true
          }
        })
        .catch(err => {
          Message.error('网络错误22，登陆失败:' + err)
        })
    },
    handleMessage: function (event) {
      var origin = event.origin
      if ((origin === 'https://login.dingtalk.com') && (event !== null)) {
        console.log('origin:' + event.data)
        var ifrm = document.createElement('iframe')
        let url = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?response_type=code&scope=snsapi_login&state=STATE&appid=' + this.appid + '&redirect_uri=REDIRECT_URI&loginTmpCode=' + event.data
        ifrm.setAttribute('src', url)
        ifrm.style.display = "none"
        document.body.appendChild(ifrm)
        // ifrm.onload = function () {
        // document.body.removeChild(ifrm)
        // }
      }
      if ((origin === 'https://static-app.97kid.com') && (event !== null)) {
        this.dingdingCode = event.data.dingTalkCode
        GetBoundAdmins(this.dingdingCode)
          .then(req => {
            switch (req.needIDInfo) {
              case 0:
                let tmparr = JSON.parse(atob(req.data))
                if (tmparr.length > 0) {
                  this.account = JSON.parse(atob(req.data))[0].mobile
                  this.dingdingLogin(JSON.parse(atob(req.data))[0].id)
                }
                break
              case 1:
                tmparr = JSON.parse(atob(req.data))
                if (tmparr.length > 0) {
                  this.account = JSON.parse(atob(req.data))[0].mobile
                  this.dingdingLogin(JSON.parse(atob(req.data))[0].id)
                }
                break
              case 2:
                this.dingdingUserArr = JSON.parse(atob(req.data))
                this.showSelectAccount = true
                break
            }
          })
          .catch(err => {
            Message.error('网络错误，登陆失败:' + err)
          })
      }
    },
    showDingCode () {
      setTimeout(function (appid) {
        let url = encodeURIComponent('https://static-app.97kid.com/student-service/dingtalk.html')
        let qrcodeurl = encodeURIComponent('https://oapi.dingtalk.com/connect/oauth2/sns_authorize?response_type=code&scope=snsapi_login&state=STATE&appid=' + appid + '&redirect_uri=' + url)
        let src = 'https://login.dingtalk.com/login/qrcode.htm?goto=' + qrcodeurl + '&style=background-color%3A%20transparent%3B%20border%3A%200%3B%20margin-top%3A%20-40px%3B'
        let ifamSrc = document.getElementById('dingifr')
        ifamSrc.removeAttribute('src')
        ifamSrc.setAttribute('src', src)
      }, 500, this.appid)
    },
    onTabChange (key, type) {
      console.log(key, type)
      this[type] = key
    },
    loginWithPhone () {
      this.isShowSmsCode = true
    },
    handleOk (e) {
      this.loading = true
      setTimeout(() => {
        this.visible = false
        this.loading = false
      }, 3000)
    },
    bindS401 () {
      let IDname = document.getElementById('IDname').value
      let IDcode = document.getElementById('IDcode').value
      let telA = document.getElementById('phone').value
      IDcode = IDcode.replace('x', 'X')
      // 正则表达式：
      var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/

      if (IDname === '' || IDcode === '' || telA === '') {
        alert('不能留空')
      } else if (idcardReg.test(IDcode)) {
        if (/^1[13456789]\d{9}$/.test(telA)) {
          if (/^[\u4E00-\u9FA5]{2,4}$/.test(IDname)) {
            var tmpaccount = ''
            if (this.s401type === 'qkids') {
              tmpaccount = this.account
            } else {
              tmpaccount = this.mathaccount
            }
            BindCall(tmpaccount, IDname, IDcode, telA, this.accesstoken, this.refreshtoken, this.s401type)
              .then((req) => {
                if (req.status === 200) {
                  Message.info('绑定成功')
                  localStorage.personID = req.personID
                  this.$router.push('/call')
                  Message.info('绑定成功，点击外呼设置勾选虚拟号城市')
                  this.$store.state.isShowCallSettingModel = true
                }
              })
              .catch(err => {
                Message.error('网络错误，绑定失败:' + err)
              })
          } else {
            alert('身份证名字为中文')
          }
        } else {
          alert('手机号格式错误，请检查手机号是否输入正确')
        }
      } else {
        alert('身份证校验不通过，请检查身份证号码输入是否正确')
      }
    },
    loginS401 () {
      let account = document.getElementById('account').value
      let password = document.getElementById('password').value
      let googleauth = document.getElementById('googleauth').value
      this.s401type = 'qkids'
      Login(account, password, googleauth)
        .then((response) => {
          if (response.status === 200) {
            Message.info('登陆成功')
            console.log(response)
            localStorage.s401type = 'qkids'
            localStorage.isAdmin = response.admin
            this.accesstoken = response.token
            this.refreshtoken = response.refreshtoken
            setUserInfo(this.accesstoken, this.refreshtoken)
            if (response.needIDInfo === 1) {
              this.visible = true
            } else {
              localStorage.personID = response.personID
              this.$router.push('/call')
            }
          } else {
            Message.error('登陆失败:' + response.msg)
          }
        })
        .catch(err => {
          Message.error('网络错误，登陆失败:' + err)
        })
    },
    loginMath () {
      let account = document.getElementById('mathaccount').value
      let password = document.getElementById('mathpassword').value
      let googleauth = document.getElementById('mathgoogleauth').value
      this.s401type = 'math'
      LoginMath(account, password, googleauth)
        .then((response) => {
          if (response.status === 200) {
            Message.info('登陆成功')
            console.log(response)
            localStorage.isAdmin = response.admin
            localStorage.s401type = 'math'
            this.accesstoken = response.token
            this.refreshtoken = response.refreshtoken
            setUserInfo(this.accesstoken, this.refreshtoken)
            if (response.needIDInfo === 1) {
              this.visible = true
            } else {
              localStorage.personID = response.personID
              this.$router.push('/call')
            }
          } else {
            Message.error('登陆失败:' + response.msg)
          }
        })
        .catch(err => {
          Message.error('网络错误，登陆失败:' + err)
        })
    }
  },
  created: function () {
    if (localStorage.token !== '') {
      // this.$router.push('/call')
    }
  },
  mounted: function () {
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', this.handleMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', this.handleMessage)
    }
  }
}
</script>

<style scoped>
input {
  width: 250px;
  margin-top: 10px;
}
#Login2 {
  height: 100%;
  background-color: #30a7d8;
  text-align: center;
  top: 0px;
  bottom: 0px;
  margin: 0;
  padding: 0;
  display: flex;
}
#LoginCard {
  background-color: #f5f5f5;
  border-radius: 0.3125rem;
  box-shadow: 0px 2px 0px rgba(170, 170, 170, 0.1);
  width: 400px;
  height: 350px;
  position: relative;
  top: calc(50vh - 200px);
  left: calc(50vw - 450px);
}
#MathLoginCard {
  background-color: #f5f5f5;
  border-radius: 0.3125rem;
  box-shadow: 0px 2px 0px rgba(170, 170, 170, 0.1);
  width: 400px;
  height: 350px;
  position: relative;
  top: calc(50vh - 200px);
  left: calc(50vw - 400px);
}
footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20px;
  background-color: #f5f5f5;
}
.auth-form-light {
  border-radius: 0.3125rem;
  box-shadow: 0px 2px 0px rgba(170, 170, 170, 0.1);
}
</style>
